<div class="steps is-vertical" role="list" [ngClass]="{ 'steps-line': showLine }">
  <ng-content />
</div>
